import { render, staticRenderFns } from "./timeline.vue?vue&type=template&id=37b6c8fe&scoped=true&"
import script from "./timeline.vue?vue&type=script&lang=js&"
export * from "./timeline.vue?vue&type=script&lang=js&"
import style0 from "./timeline.vue?vue&type=style&index=0&id=37b6c8fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6c8fe",
  null
  
)

export default component.exports